import { Routes } from '@angular/router';
import { AdminGuard } from '../../app/common/guards/admin'; // adjust to your file name
import { Role } from '../common/models/role';
import { HomeComponent } from './home/home';
import { IdentityDashboardComponent } from './identity/identity-dashboard/identity-dashboard';

export const MAIN_ROUTES: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'error',
    loadChildren: () => import('./error/error.routes').then(m => m.ERROR_ROUTES)
  },
 {
  path: 'dashboard',
  canActivate: [AdminGuard], // any logged-in user
  loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
},
{
  path: 'identity',
  canActivate: [AdminGuard],
  data: { roles: [Role.IdentitySuperAdmin] }, // or ['Admin']
  loadChildren: () => import('./identity/identity.routes').then(m => m.IDENTITY_ROUTES),
},
{
  path: 'identity-HR',
  canActivate: [AdminGuard],
  data: { roles: ['IdentityModerator'] }, // use your exact HR role name
  loadChildren: () => import('./identity-HR/identity-HR.routes').then(m => m.IDENTITY_HR_ROUTES),
},
  {
    path: 'identity/identity-dashboard',
    component: IdentityDashboardComponent,
  },
  

  
];
